import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  appointmentActions,
  appointmentDraftActions,
  journeyStateActions,
  appointmentDraftSelectors,
} from '~/api';

import { questionHelpers, withProgressBar, envConfigSelectors } from '~/components';
import { isEmpty } from '~/utils';
import { formatToTemporaryState } from '~/routes/edit/common/helpers';
import {
  getTokenFromStorage,
  setTokenToStorage,
  TEMPORARY_TOKEN_NAME,
} from '~/components/persist-token/persist-token.utils';
import {
  EditDate as DefaultEditDate,
  saveTemporaryAppointment,
  saveTemporaryJourneyState,
} from '../../common';

export class EditAppointmentDate extends PureComponent {
  componentDidMount() {
    const {
      draft,
      journeyState,
      temporaryAppointment,
      temporaryJourneyState,
      dispatchSaveTemporaryAppointment,
      dispatchSaveTemporaryJourneyState,
    } = this.props;
    if (isEmpty(temporaryAppointment)) {
      dispatchSaveTemporaryAppointment(formatToTemporaryState(draft));
      setTokenToStorage(getTokenFromStorage(), TEMPORARY_TOKEN_NAME);
    }
    if (isEmpty(temporaryJourneyState)) {
      dispatchSaveTemporaryJourneyState(journeyState);
      setTokenToStorage(getTokenFromStorage(), TEMPORARY_TOKEN_NAME);
    }
  }

  onSaveDataHandler = () => {
    const {
      draft: {
        shop: { id: selectedShopId },
      },
      temporaryAppointment: {
        shop: { id: shopId },
      },
      appointmentTypeId,
      addressQuestionId,
      address,
      dispatchSaveAppointmentDraft,
      dispatchLoadAppointment,
      dispatchSaveJourneyState,
      answers,
      displayUserAddress,

      dispatchUpdateAppointment,
    } = this.props;

    const updatedAddressAnswer =
      displayUserAddress && addressQuestionId
        ? {
            answers: [...answers, ...questionHelpers.getAddressAnswer(address, appointmentTypeId)],
          }
        : {};

    return dispatchUpdateAppointment({ ...updatedAddressAnswer }, shopId)
      .then(() => dispatchSaveAppointmentDraft())
      .then(() => dispatchSaveJourneyState())
      .then(() => dispatchLoadAppointment(selectedShopId));
  };

  render() {
    const { EditDate } = this.props;
    return <EditDate onSaveDataHandler={this.onSaveDataHandler} {...this.props} />;
  }
}

export const mapStateToProps = (state) => {
  const {
    appointment: { appointment, draft },
    editAppointment: { temporaryAppointment, temporaryJourneyState },
    services: { config },
    envConfig,
    journeyState,
  } = state;
  const { addressQuestionId } = envConfigSelectors.selectAppointmentTypeConfig(
    envConfig,
    draft.appointmentType.id,
  );

  return {
    draft,
    address: appointmentDraftSelectors.selectAddress(state),
    journeyState,
    temporaryAppointment,
    temporaryJourneyState,
    EditDate: envConfigSelectors.selectEditDateComponent(state),
    answers:
      (appointment &&
        appointment.answers &&
        appointment.answers.filter((answer) => answer.questionId !== addressQuestionId)) ||
      [],
    displayUserAddress: !!config.BookingReview && config.BookingReview.displayUserAddress,
    appointmentTypeId: draft.appointmentType.id,
    addressQuestionId,
  };
};

const mapDispatchToProps = {
  dispatchSaveAppointmentDraft: appointmentDraftActions.saveAppointmentDraft,
  dispatchLoadAppointment: appointmentActions.loadAppointment,
  dispatchSaveJourneyState: journeyStateActions.saveJourneyState,
  dispatchSaveTemporaryAppointment: saveTemporaryAppointment,
  dispatchSaveTemporaryJourneyState: saveTemporaryJourneyState,
  dispatchUpdateAppointment: appointmentActions.updateAppointment,
};

export const ConnectedEditAppointmentDate = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withProgressBar(EditAppointmentDate));

EditAppointmentDate.propTypes = {
  temporaryAppointment: PropTypes.shape({}).isRequired,
  temporaryJourneyState: PropTypes.shape({}).isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  displayUserAddress: PropTypes.bool,
  draft: PropTypes.shape({
    shop: PropTypes.shape({}).isRequired,
    id: PropTypes.string,
  }).isRequired,
  journeyState: PropTypes.shape({}).isRequired,
  address: PropTypes.shape().isRequired,
  appointmentTypeId: PropTypes.string.isRequired,
  addressQuestionId: PropTypes.string,

  dispatchLoadAppointment: PropTypes.func.isRequired,
  dispatchSaveAppointmentDraft: PropTypes.func.isRequired,
  dispatchSaveJourneyState: PropTypes.func.isRequired,
  dispatchSaveTemporaryAppointment: PropTypes.func.isRequired,
  dispatchSaveTemporaryJourneyState: PropTypes.func.isRequired,
  dispatchUpdateAppointment: PropTypes.func.isRequired,

  EditDate: PropTypes.func,
};

EditAppointmentDate.defaultProps = {
  EditDate: DefaultEditDate,
  displayUserAddress: false,
  addressQuestionId: null,
};
